import {
  FETCH_OPTIONS_START,
  FETCH_OPTIONS_SUCCESS,
  FETCH_OPTIONS_ERROR,
  CREATE_OPTION_START,
  CREATE_OPTION_SUCCESS,
  CREATE_OPTION_ERROR,
  DELETE_OPTION_START,
  DELETE_OPTION_SUCCESS,
  DELETE_OPTION_ERROR,
  UPDATE_OPTION_START,
  UPDATE_OPTION_ERROR,
  UPDATE_OPTION_SUCCESS,
  SET_SELECTED_OPTIONS,
  CLEAN_SELECTED_OPTIONS,
  SEND_CALCULATION_START,
  SEND_CALCULATION_SUCCESS,
  RESET_MAIL_SENT,
} from "./options.types"

// Options actions
export const fetchOptionsStart = () => ({
  type: FETCH_OPTIONS_START,
})
export const fetchOptionsSuccess = (data) => ({
  type: FETCH_OPTIONS_SUCCESS,
  payload: data,
})
export const fetchOptionsError = (error) => ({
  type: FETCH_OPTIONS_ERROR,
  payload: error,
})

// Single category actions
export const createOptionStart = (option) => ({
  type: CREATE_OPTION_START,
  payload: option,
})

export const createOptionSuccess = (option) => ({
  type: CREATE_OPTION_SUCCESS,
  payload: option,
})

export const createOptionError = (option) => ({
  type: CREATE_OPTION_ERROR,
  payload: option,
})

export const updateOptionStart = (option) => ({
  type: UPDATE_OPTION_START,
  payload: option,
})

export const updateOptionSuccess = (option) => ({
  type: UPDATE_OPTION_SUCCESS,
  payload: option,
})

export const updateOptionError = (option) => ({
  type: UPDATE_OPTION_ERROR,
  payload: option,
})

export const deleteOptionStart = (option) => ({
  type: DELETE_OPTION_START,
  payload: option,
})

export const deleteOptionSuccess = (data) => ({
  type: DELETE_OPTION_SUCCESS,
  payload: data,
})

export const deleteOptionError = (error) => ({
  type: DELETE_OPTION_ERROR,
  payload: error,
})

export const resetMailSent = () => ({
  type: RESET_MAIL_SENT,
})

// Sum calculation actions
export const setSelectedOptions = (options) => ({
  type: SET_SELECTED_OPTIONS,
  payload: options,
})

export const cleanSelectedOptions = () => ({ type: CLEAN_SELECTED_OPTIONS })

export const sendCalculationStart = (payload) => ({
  type: SEND_CALCULATION_START,
  payload,
})

export const sendCalculationSuccess = () => ({
  type: SEND_CALCULATION_SUCCESS,
})
